import React from 'react';

import StepsLayout from '../../../StepsLayout';

const CreateApplication: React.FC = () => {
  return <StepsLayout />;
};

export default CreateApplication;
